import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { colors, fonts } from '../brand';
import SiteNav from '../components/SiteNav';
import SiteFooter from '../components/SiteFooter';
import Disclaimer from '../components/Disclaimer';

export default function About() {
  return (
    <div style={styles.page}>
      <Helmet>
        <title>About — Elephants Answering</title>
        <meta name="description" content="Built by someone who's been there. Amy founded Elephants Answering after navigating a high-conflict divorce — because no woman should go through it alone or uninformed." />
      </Helmet>
      <SiteNav />

      {/* Hero */}
      <section style={styles.hero}>
        <div style={styles.heroInner}>
          <h1 style={styles.heroTitle}>Built by someone who's been there.</h1>
        </div>
      </section>

      {/* Founder letter */}
      <section style={styles.section}>
        <div style={styles.inner}>
          <p style={styles.body}>Hi,</p>
          <p style={styles.body}>There comes a time when enough is enough — whether it's a job, a friend, a partner, or something else entirely. For me, it's the court system and the seven years I've been tangled up in it. What started as a divorce case in family court eventually spilled into four additional courts I didn't even know existed. It didn't take long to realize my ex-husband understood the system in ways I didn't, and the advantage that gave him — and still gives him — is hard to put into words.</p>
          <p style={styles.body}>I've learned more about the American judicial system than I ever wanted to know, and I'm going to share it. I hope you'll share yours too. The hard truth is that too many of us can relate to each other's stories, and the more we talk, the better prepared the next woman will be — whether she's just starting the process, in the thick of it, or finding her way out.</p>
          <p style={styles.body}>I built Elephants Answering as a place to take everything I've learned — alongside other women who've lived it — and do something with it: the kids, the courts, the hidden assets, the betrayal, the constant surprises, the brilliant life after.</p>
          <p style={styles.body}>Because the truth is, it's too much to carry alone.</p>
          <p style={styles.body}>Wherever you are — contemplating, in it, or rebuilding — I hope you find something here that helps.</p>
          <p style={styles.body}>Elephants Answering is a Public Benefit Corporation built to help you feel more informed, more prepared, and less alone — through real stories, shared experience, and tools that support you along the way.</p>
          <p style={styles.body}>You won't go in blind. And you won't go in alone.</p>
          <p style={styles.body}>We're just getting started.</p>
          <p style={styles.signature}>— Amy<br />Founder, Elephants Answering, PBC</p>
        </div>
      </section>

      {/* The name */}
      <section style={styles.darkSection}>
        <div style={styles.darkInner}>
          <h2 style={styles.darkTitle}>Why Elephants?</h2>
          <p style={styles.darkBody}>
            Elephants live in matriarchal societies. When one is in distress, they call to warn each other of danger to protect the herd. Elephants Answering honors this instinct — women supporting women, showing up for each other in the hardest moments.
          </p>
        </div>

      </section>
      {/* CTA */}
      <section style={styles.ctaSection}>
        <Link to="/register" style={styles.ctaBtn}>
          Join the Community
        </Link>
        <p style={styles.ctaTagline}>Free for Early Members</p>
      </section>

      <Disclaimer />
      <SiteFooter />
    </div>
  );
}

const styles = {
  page: { fontFamily: fonts.body, backgroundColor: colors.cream, minHeight: '100vh' },

  hero: { background: `linear-gradient(150deg, ${colors.navy} 0%, #003366 100%)`, padding: '80px 20px' },
  heroInner: { maxWidth: '680px', margin: '0 auto', textAlign: 'center' },
  eyebrow: { fontFamily: fonts.body, color: colors.peach, fontSize: '11px', letterSpacing: '2.5px', textTransform: 'uppercase', marginBottom: '20px' },
  heroTitle: { fontFamily: fonts.heading, color: colors.white, fontSize: '40px', lineHeight: '1.35', fontWeight: '600', letterSpacing: '0.5px', margin: 0 },

  section: { padding: '72px 20px' },
  inner: { maxWidth: '720px', margin: '0 auto' },
  sectionTitle: { fontFamily: fonts.heading, color: colors.navy, fontSize: '28px', fontWeight: '600', letterSpacing: '0.3px', marginBottom: '40px', textAlign: 'center' },
  body: { fontFamily: fonts.body, color: colors.textMedium, fontSize: '15px', lineHeight: '1.7', marginBottom: '12px' },
  shameList: { fontFamily: fonts.body, color: colors.textMedium, fontSize: '15px', lineHeight: '1.7', marginBottom: '12px', paddingLeft: '0', listStyle: 'none' },
  shameItem: { marginBottom: '0' },
  signature: { fontFamily: fonts.heading, color: colors.navy, fontSize: '16px', lineHeight: '1.8', marginTop: '36px', fontStyle: 'italic', fontWeight: '500' },

  darkSection: { backgroundColor: colors.navy, padding: '72px 20px' },
  darkInner: { maxWidth: '680px', margin: '0 auto', textAlign: 'center' },
  darkTitle: { fontFamily: fonts.heading, color: colors.white, fontSize: '28px', fontWeight: '600', letterSpacing: '0.3px', marginBottom: '24px' },
  darkBody: { fontFamily: fonts.body, color: 'rgba(255,255,255,0.7)', fontSize: '16px', lineHeight: '2' },

  beliefs: { display: 'flex', flexDirection: 'column', gap: '32px' },
  belief: { borderLeft: `3px solid ${colors.rose}`, paddingLeft: '24px' },
  beliefTitle: { fontFamily: fonts.heading, color: colors.navy, fontSize: '16px', fontWeight: '600', marginBottom: '8px', letterSpacing: '0.3px' },
  beliefBody: { fontFamily: fonts.body, color: colors.textMedium, fontSize: '14px', lineHeight: '1.9', margin: 0 },

  ctaSection: { backgroundColor: colors.offWhite, padding: '80px 20px', textAlign: 'center', borderTop: `1px solid ${colors.peach}` },
  ctaBtn: { backgroundColor: colors.rose, color: colors.white, textDecoration: 'none', padding: '16px 40px', borderRadius: '2px', fontSize: '14px', fontWeight: '600', fontFamily: fonts.body, letterSpacing: '0.5px', display: 'inline-block' },
  ctaTagline: { fontFamily: fonts.body, color: colors.textMedium, fontSize: '12px', marginTop: '12px' },
};
